import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "form", "title"]

  open(event) {
    if (!this.hasDialogTarget) {
      return
    }

    const trigger = event?.currentTarget
    const actionUrl = trigger?.dataset?.actionUrl
    const questionTitle = trigger?.dataset?.questionTitle

    if (this.hasFormTarget && actionUrl) {
      this.formTarget.action = actionUrl
    }

    if (this.hasTitleTarget) {
      const defaultTitle = this.titleTarget.dataset.defaultTitle || this.titleTarget.textContent
      this.titleTarget.textContent = questionTitle ? `${defaultTitle}: ${questionTitle}` : defaultTitle
    }

    const inputs = this.dialogTarget.querySelectorAll("input[type='checkbox']")
    inputs.forEach((input) => {
      input.checked = false
    })

    this.showDialog()
  }

  close() {
    if (!this.hasDialogTarget) {
      return
    }

    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }

  showDialog() {
    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "open")
    }
  }
}
